import api from '../api';

export async function getServerVersion() {
    try {
        const response = await api.get('/api/version');

        return {
            versaoBack: response?.data?.version || '',
            banco: response?.data?.banco || '',
        };
    } catch (error) {
        console.error('Erro ao obter versão do backend', error);
        return {
            versaoBack: '',
            banco: '',
        };
    }
}
